/* eslint-disable consistent-return,react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';

import { NEW_MESSAGE_ERRORS } from '../../../constants/chat';
import ClickableElement from '../../ClickableElement';

export default class FilePicker extends PureComponent {
  input = null;

  @autobind
  handleFilePick(e) {
    const { onError, onFilePick } = this.props;

    e.stopPropagation();
    e.preventDefault();

    const fileSource = e.target;
    const { multiple } = fileSource;

    const files = [];

    Array.from(fileSource.files).forEach(file => {
      files.push(file);
    });

    if (!files) return;

    const errors = this.validateFile(files);
    if (errors) return onError(errors);

    if (!multiple) {
      const file = files[0];
      onFilePick(file);
    } else {
      onFilePick(files);
    }
    // Prevent not firing change event for the same file twice
    e.target.value = '';
  }

  validateFile(files) {
    const errors = [];
    const errorFiles = [];
    const {
      maxSize,
      allowedFormats,
      validFileExtensions,
      maxAttachmentNumber,
    } = this.props;

    if (files.length > maxAttachmentNumber) {
      errors.push(NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_NUMBER);
    }

    if (!maxSize && !allowedFormats) return false;
    files.forEach(file => {
      const size = file.size / 1024 / 1024;
      const exceedMaxSize = Math.ceil(size) > maxSize;

      if (maxSize && exceedMaxSize) {
        errors.push(NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE);
        errorFiles.push(file.name);
      }
      if (file.type) {
        if (allowedFormats && !allowedFormats.includes(file.type)) {
          errors.push(NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT);
        }
      } else {
        const fileExtension = file.name.split('.').pop();
        if (
          validFileExtensions &&
          !validFileExtensions.includes(fileExtension)
        ) {
          errors.push(NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT);
        }
      }
    });

    return errors.length ? { errors, errorFiles } : false;
  }

  // Used from outside
  forcePick() {
    this.input.click();
  }

  render() {
    const {
      inputFileLabel,
      disabled,
      children,
      multiple,
      allowedFormats,
    } = this.props;
    const acceptFormats = allowedFormats.join(' ,');

    return (
      <div>
        <label htmlFor={inputFileLabel}>
          <ClickableElement>{children}</ClickableElement>
        </label>
        <input
          ref={node => (this.input = node)}
          id={inputFileLabel}
          type="file"
          style={{ display: 'none' }}
          onChange={this.handleFilePick}
          disabled={disabled}
          multiple={multiple}
          accept={acceptFormats}
        />
      </div>
    );
  }
}

FilePicker.propTypes = {
  onFilePick: PropTypes.func,
  onError: PropTypes.func,
  inputFileLabel: PropTypes.string,
  maxSize: PropTypes.number,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  allowedFormats: PropTypes.array,
  multiple: PropTypes.bool,
  validFileExtensions: PropTypes.array,
  maxAttachmentNumber: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/Chat/components/FilePicker.jsx